// extracted by mini-css-extract-plugin
export default {"otpContainer":"OtpInput_otpContainer__OYO+N","otpInput":"OtpInput_otpInput__Kc-cy","otpInputError":"OtpInput_otpInputError__K0mTa"};